export const circle = rem => ({
	width: `${rem || 1.8}rem`,
	height: `${rem || 1.8}rem`,
	lineHeight: `${rem || 1.8}rem`,
	textAlign: 'center',
	borderRadius: '100%'
});
